import './App.css'
import Playground from './components/Playground'
import TileGrid from './components/TileGrid'
import TopBar from './components/TopBar'
import WeirdButtons from './components/WeirdButtons'
import { TILE_DATA } from './data/tiles'

function App() {
  const isPortfolio = window.location.pathname === '/portfolio'
  const isWeirdButtons = window.location.pathname === '/weird-buttons'

  return (
    <div className="portfolio">
      <TopBar isPortfolio={isPortfolio} />
      {isPortfolio ? (
        <TileGrid tiles={TILE_DATA} />
      ) : isWeirdButtons ? (
        <WeirdButtons />
      ) : (
        <Playground />
      )}
    </div>
  )
}

export default App
